<template>
  <div id="rtg-section">
    <div class="ready-to-start-text">
      Ready to get started? Let's find your provider
    </div>
    <PrimaryButton
      class="primarybutton"
      :text="'Find Your Provider'"
      @clickHandler="findyourproviderClick"
    />
  </div>
</template>

<script>
import PrimaryButton from "@Shared/components/PrimaryButton.vue";
import router from "../../router";

export default {
  name: "Readytogetstarted",
  components: {
    PrimaryButton,
  },

  methods: {
    findyourproviderClick() {
      router.push({ name: "search" });
    },
  },
};
</script>

<style lang="scss" scoped>
#rtg-section {
  display: grid;
  grid-template-columns: 80% auto;
  background-color: #e5f2f6;
  box-shadow: 0px 3px 1px -2px rgba(30, 30, 37, 0.1),
    0px 2px 3px 0px rgba(30, 30, 37, 0.16);
  margin: 5vh 5vh 5vh 10vh;
  padding: 1.5% 4% 1.5% 4%;
  

  @media all and (max-width: $grid-breakpoint-lg) {
    display: grid;
    grid-template-columns: 1fr;
    margin: 0 0 30px 0;
    padding: 10%;
    row-gap: 15px;
  }

  .ready-to-start-text {
    font-family: Poppins;
    font-size: 28px;
    font-weight: 500;
    margin: auto 0;

    @media all and (max-width: $grid-breakpoint-lg) {
      font-family: Poppins;
      font-size: 24px;
      font-weight: 500;
      line-height: 36px;
      letter-spacing: 0px;
      text-align: left;
    }
  }

  .primarybutton {
    border-radius: 10px;
    border: 2px solid var(--primary-ada-blue-100, #007aa3);
    box-shadow: 0px 3px 5px -1px rgba(30, 30, 37, 0.1),
      0px 6px 10px 0px rgba(30, 30, 37, 0.16);
    background-color: white;
    cursor: pointer;
    transition: background-color 100ms linear;

    &:hover {
      background-color: var(--primary-ada-blue-100, #007aa3);
      transition: background-color 100ms linear;

      .text-style {
        color: var(--shades-white-ffffff, #fff);
      }
    }

    &:active {
      background: var(--primary-ada-blue-100, #004e69);

      .text-style {
        color: var(--shades-white-ffffff, #fff);
      }
    }
  }
}
</style>
